export const isDeviceMobile = () => {
  if (typeof window === 'undefined') {
    return true;
  }

  return window.innerWidth < 768;
};
